import { store } from '../../store'
import { NOTIFIER_SHOW }  from './types'

export const showNotification = ({ isError = false, message }) => {
    store.dispatch({ type: NOTIFIER_SHOW, notification: { message, type: isError ? 'fail' : 'success' } })
}